module.exports = __webpack_public_path__ + "static/media/paysucessul.8a3893bc.svg";